// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"175":"582b421d","884":"29ad4600"}[chunkId] + ".chunk.js";
};